const lisacomunica_automodal = {
  namespaced: true,
  state: {
    status: "",
    // Usato nel salto/passaggio dal quietanzamento al modulo Lisa Comunica, una volta premuto
    // sul pulsante "Invia selezionati"
    showAutoModal: false,
    fromAncillaries: false,
  },

  mutations: {
    LISACOMUNICA_AUTOMODAL_SAVE(state, value) {
      state.showAutoModal = value;
      state.status = "saved";
    },
    LISACOMUNICA_AUTOMODAL_FROM_ANCILLARIES(state, value) {
      state.fromAncillaries = value;
    },
  },

  actions: {
    saveLisacomunicaAutoModal({ commit }, value) {
      commit("LISACOMUNICA_AUTOMODAL_SAVE", value);
    },
    saveLisacomunicaFromAncillaries({ commit }, value) {
      commit("LISACOMUNICA_AUTOMODAL_FROM_ANCILLARIES", value);
    },
  },
  getters: {
    isShowAutoModal: (state) => {
      return state.showAutoModal;
    },
    isFromAncillaries: (state) => {
      return state.fromAncillaries;
    },
  },
};

export default lisacomunica_automodal;
